<template>
  <div>
    <h5 class="mb-3">{{ $t('registration.title') }}</h5>
    <div v-if="registration && registration.failure" class="alert alert-danger">
      {{registration.message.text}}.
      <button
        v-if="registration.message.code === 'user_exist'"
        type="button"
        class="btn btn-link btn-sm p-0 alert-link"
        @click="switchMode('repassword')"
      >{{ $t('login.forgot.password') }}</button>
    </div>
    <form @submit.prevent="handleSubmit">
      <div class="mb-3">
        <label class="form-label" for="register-email">Email</label>
        <input id="register-email" class="form-control" type="email" name="email" v-model="email" />
      </div>
      <button class="btn btn-primary w-100">{{ $t('registration.submit') }}</button>
      <div class="mt-3 small text-muted">
        {{ $t('registration.already.registered') }}
        <button
          type="button"
          class="btn btn-link btn-sm p-0 align-baseline"
          @click="switchMode('login')"
        >{{ $t('registration.login') }}</button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: ""
    };
  },
  computed: {
    registration() {
      return this.$store.state.auth.registration;
    }
  },
  methods: {
    handleSubmit() {
      if (this.email) {
        this.$store.dispatch("auth/register", {
          email: this.email,
          userType: "user"
        });
      }
    },
    switchMode(mode) {
      this.$emit("changeMode", mode);
    }
  }
};
</script>